/**
 * Kişisel kod: 8 rakam, sunucuya gruplamasız gider. Gösterimde 4+4
 * gruplanır ("4821 · 0937"). Mobil ve sunucudaki kuralla aynı.
 */
export const MEMBER_CODE_LENGTH = 8;

/** Yapıştırılan metinden en fazla 8 rakam; Arapça ve Farsça rakamlar çevrilir. */
export function codeDigits(raw) {
  return String(raw || "")
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06f0))
    .replace(/\D/g, "")
    .slice(0, MEMBER_CODE_LENGTH);
}

export function formatCode(raw) {
  const digits = codeDigits(raw);
  return digits.length <= 4 ? digits : `${digits.slice(0, 4)} · ${digits.slice(4)}`;
}
